
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Xmh2", function(module, exports) {
$parcel$export(module.exports, "PasswordResetPage", function () { return (parcelRequire("20Q3e")).PasswordResetPage; });
parcelRequire("20Q3e");

});
parcelRegister("20Q3e", function(module, exports) {

$parcel$export(module.exports, "PasswordResetPage", function () { return $601988adad8443e8$export$5bbd98196cb66ba8; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $ka0YZ = parcelRequire("ka0YZ");

var $1xw2Y = parcelRequire("1xw2Y");

var $gfjRp = parcelRequire("gfjRp");

var $klmJ0 = parcelRequire("klmJ0");

var $8LupL = parcelRequire("8LupL");

var $jyUmz = parcelRequire("jyUmz");

var $li3ww = parcelRequire("li3ww");

var $bahbp = parcelRequire("bahbp");

var $jyHXF = parcelRequire("jyHXF");
parcelRequire("kX58s");
var $jCUUk = parcelRequire("jCUUk");

var $lSK2P = parcelRequire("lSK2P");

var $aL1Vp = parcelRequire("aL1Vp");
const $601988adad8443e8$var$SFormWrapper = (0, $akcQ4.default)((0, $li3ww.SContentWrapper))`
    width: 100%;
    max-width: 435px;
`;
function $601988adad8443e8$export$5bbd98196cb66ba8({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const { value: value, apply: apply } = (0, $gfjRp.default)({
        password: "",
        passwordCompare: ""
    });
    const [error, setError] = (0, $6uMv9.useState)("");
    const [submitError, setSubmitError] = (0, $6uMv9.useState)(false);
    const [showPassword, toggleShowPassword] = (0, $6uMv9.useState)(false);
    const [showPasswordCompare, toggleShowPasswordCompare] = (0, $6uMv9.useState)(false);
    const navigate = (0, $iZaUM.useNavigate)();
    const [searchParams] = (0, $iZaUM.useSearchParams)();
    const { execute: resetPassword, status: status } = (0, $ka0YZ.default)((token, value)=>(0, $jyHXF.default)(token, value).then(()=>{
            (0, $lSK2P.default).setItem("notification", {
                text: "msgPasswordReset"
            });
            navigate("/login", {
                replace: true
            });
        }).catch(()=>setSubmitError(true)));
    const handleSubmit = (0, $6uMv9.useCallback)((event)=>{
        event.preventDefault();
        const token = searchParams?.get("token");
        if (!token) return;
        if (value.password !== value.passwordCompare) {
            setError(text("msgPasswordDoNotMatch"));
            return;
        }
        if (value.password.length < 8) {
            setError(text("msgPasswordToShortSignup"));
            return;
        }
        resetPassword(token, value);
    }, [
        value,
        searchParams
    ]);
    const changeValue = (value)=>{
        setError("");
        apply(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        background: (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM && (0, $8LupL.default) === (0, $8LupL.SiteDomain).ADMIN ? "#6ebf7d" : "#ffffff",
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($601988adad8443e8$var$SFormWrapper, null, submitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SNotification), {
        "data-testid": "signInError",
        error: submitError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgPasswordNotChanged"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jyUmz.FormHeader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "passwordForm",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bahbp.PasswordInput), {
        label: value.password.length > 0 ? text("lblPassword") : "",
        placeholder: text("lblPassword"),
        onChange: (value)=>changeValue({
                password: value
            }),
        showPassword: showPassword,
        message: !value.password ? text("msgMinimumPasswordLength") : null,
        error: error,
        errorTestId: "passwordInputError",
        toggleShowPasswordFlag: toggleShowPassword,
        hasText: value.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bahbp.PasswordInput), {
        label: value.passwordCompare.length > 0 ? text("lblConfirmPasswordField") : "",
        placeholder: text("lblConfirmPasswordField"),
        onChange: (value)=>changeValue({
                passwordCompare: value
            }),
        showPassword: showPasswordCompare,
        toggleShowPasswordFlag: toggleShowPasswordCompare,
        hasText: value.passwordCompare.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jCUUk.SubmitButton), {
        disabled: !value.password || !value.passwordCompare || status === (0, $ka0YZ.Status).PENDING
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnResetPassword"
    }))))));
}

});
parcelRegister("jyHXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85aa41901389eaf0$export$2e2bcd8739ae039; });

var $bhqzv = parcelRequire("bhqzv");
const $85aa41901389eaf0$var$resetUserPassword = (token, data)=>(0, $bhqzv.default)({
        method: "PUT",
        path: `/auth/password/reset/${token}`,
        body: data
    });
var $85aa41901389eaf0$export$2e2bcd8739ae039 = $85aa41901389eaf0$var$resetUserPassword;

});

parcelRegister("kX58s", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return (parcelRequire("jCUUk")).SubmitButton; });
parcelRequire("jCUUk");

});
parcelRegister("jCUUk", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $3f7f711e298c6730$export$8b7b7cdfb85d78c5; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $lWDz3 = parcelRequire("lWDz3");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $78aLY = parcelRequire("78aLY");

var $klmJ0 = parcelRequire("klmJ0");
const $3f7f711e298c6730$export$e97afde9f5f901c8 = (0, $akcQ4.default).button`
    display: flex;
    min-width: 150px;
    margin: 0 auto;
    padding: 9px 46px;
    border-radius: 16px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border: none;
    transition: 0.2s ease;
    font-size: 15px;
    svg {
        path {
            fill: ${({ fortum: fortum, theme: theme })=>fortum ? theme.fortumTheme.defaultColor : theme.font.successColor};
        }
    }

    &[disabled],
    &[disabled]:active:not(:hover) {
        background-color: #e6e6e6;
        color: ${({ theme: theme })=>theme.font.lightestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &.inverted {
        background-color: #fff;
        color: #000;
    }

    &:hover {
        background-color: ${({ fortum: fortum, theme: theme })=>fortum ? theme.fortumTheme.secondaryColor : theme.font.successColor};
        color: #000;

        svg {
            path {
                fill: ${({ fortum: fortum, theme: theme })=>fortum ? theme.fortumTheme.defaultColor : theme.font.lightestColor};
            }
        }
    }
    &:active,
    &:active:not(:hover) {
        background-color: #d9edd9;
        color: ${({ theme: theme })=>theme.font.darkestColor};

        svg {
            path {
                fill: ${({ fortum: fortum, theme: theme })=>fortum ? theme.fortumTheme.defaultColor : theme.font.lightestColor};
            }
        }
    }

    &[disabled]:hover {
        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
        color: ${({ theme: theme })=>theme.font.lightestColor};
        background-color: #e6e6e6;
    }
`;
function $3f7f711e298c6730$export$8b7b7cdfb85d78c5({ children: children, className: className, style: style, inverted: inverted, disabled: disabled, loading: loading = false }) {
    const isFortumDomain = (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($3f7f711e298c6730$export$e97afde9f5f901c8, {
        fortum: isFortumDomain,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className, {
            inverted: inverted
        }),
        style: style,
        "data-testid": "submitButton",
        type: "submit",
        disabled: disabled
    }, children, " ", !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $78aLY.SignInArrowIcon), {
        className: "ml-2"
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
        icon: (0, $iJ6Cm.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }));
}

});




parcelRegister("ieBDX", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return (parcelRequire("4Ye6z")).ResetPasswordRequestPage; });
parcelRequire("4Ye6z");

});
parcelRegister("4Ye6z", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return $bfd47ecd4788494a$export$d071176b85126a1a; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $ka0YZ = parcelRequire("ka0YZ");

var $1xw2Y = parcelRequire("1xw2Y");

var $li3ww = parcelRequire("li3ww");

var $6bALw = parcelRequire("6bALw");

var $klmJ0 = parcelRequire("klmJ0");

var $8LupL = parcelRequire("8LupL");

var $4HVy7 = parcelRequire("4HVy7");

var $jeMq0 = parcelRequire("jeMq0");

var $jyUmz = parcelRequire("jyUmz");
parcelRequire("kX58s");
var $jCUUk = parcelRequire("jCUUk");

var $lG0u6 = parcelRequire("lG0u6");

var $aL1Vp = parcelRequire("aL1Vp");
const $bfd47ecd4788494a$var$SFormWrapper = (0, $akcQ4.default)((0, $li3ww.SContentWrapper))`
    max-width: 510px;
    padding: 0 10px;
`;
const $bfd47ecd4788494a$var$SLink = (0, $akcQ4.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        font-weight: 400;
        text-align: center;
        width: 100%;
        display: inline-block;
        padding-top: 30px;
    }
`;
const $bfd47ecd4788494a$var$SInstruction = (0, $akcQ4.default).div`
    line-height: 1.5em;
    font-weight: 400;
    padding-bottom: 37px;
    text-align: center;
`;
const $bfd47ecd4788494a$var$SHeaderWrapper = (0, $akcQ4.default).div`
    padding-bottom: 45px;
`;
function $bfd47ecd4788494a$export$d071176b85126a1a({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [email, setEmail] = (0, $6uMv9.useState)("");
    const [errorMessage, setErrorMessage] = (0, $6uMv9.useState)("");
    const navigate = (0, $iZaUM.useNavigate)();
    const { execute: execute, status: status } = (0, $ka0YZ.default)((email)=>(0, $6bALw.default)(email).then(()=>{
            navigate("/reset-password-request-success", {
                replace: true
            });
        }).catch((error)=>{
            if (error?.messageCode === "msgEmailDoesntExist") {
                setErrorMessage(text("msgEmailDoesntExist", {
                    company: (0, $klmJ0.currentCompany)
                }));
                return;
            }
            navigate("/reset-password-request-error", {
                replace: true
            });
        }));
    const handleSubmit = (0, $6uMv9.useCallback)((event)=>{
        event.preventDefault();
        if (!(0, $4HVy7.validateEmailFormat)(email)) {
            setErrorMessage(text("msgEmailFormatIncorrect"));
            return;
        }
        execute(email);
    }, [
        email
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        background: (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM && (0, $8LupL.default) === (0, $8LupL.SiteDomain).ADMIN ? (0, $lG0u6.theme).greenBackground : (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($bfd47ecd4788494a$var$SFormWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($bfd47ecd4788494a$var$SHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jyUmz.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($bfd47ecd4788494a$var$SInstruction, {
        "data-testid": "description"
    }, (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM && (0, $8LupL.default) === (0, $8LupL.SiteDomain).ADMIN ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFortumResetPasswordInstruction"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgChargeAmpsResetPasswordInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "form",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeMq0.InputGroup), {
        errorTestId: "errorMsg",
        errorMsg: errorMessage,
        inverted: false,
        label: email && text("lblEmailField")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeMq0.SInput), {
        placeholder: text("lblEmailField"),
        onInput: (event)=>{
            const value = event.target.value;
            setErrorMessage("");
            setEmail(value);
        },
        value: email,
        "data-testid": "emailInput"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jCUUk.SubmitButton), {
        disabled: status === (0, $ka0YZ.Status).PENDING
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnResetPassword"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($bfd47ecd4788494a$var$SLink, {
        as: (0, $iZaUM.Link),
        to: "/login",
        "data-testid": "returnBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnReturnToSignIn"
    }))));
}

});
parcelRegister("6bALw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25cfd4717707bc30$export$2e2bcd8739ae039; });

var $2R6lm = parcelRequire("2R6lm");

var $bhqzv = parcelRequire("bhqzv");
const $25cfd4717707bc30$var$requestPasswordReset = (email)=>(0, $bhqzv.default)({
        method: "PUT",
        path: "/auth/password/reset/request",
        query: {
            hosturl: (0, $2R6lm.default)()
        },
        body: {
            email: email
        }
    });
var $25cfd4717707bc30$export$2e2bcd8739ae039 = $25cfd4717707bc30$var$requestPasswordReset;

});
parcelRegister("2R6lm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1df5c12b890de1$export$2e2bcd8739ae039; });

var $8LupL = parcelRequire("8LupL");
const $7c1df5c12b890de1$var$getHostUrl = ()=>{
    if (0, $8LupL.isUserappDomain) return location.origin + "/userapp";
    else if (0, $8LupL.isPartnerDomain) return location.origin + "/partner";
    else return location.origin + "/admin";
};
var $7c1df5c12b890de1$export$2e2bcd8739ae039 = $7c1df5c12b890de1$var$getHostUrl;

});




parcelRegister("d1vMk", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return (parcelRequire("cuGBI")).ResetPasswordRequestSuccessPage; });
parcelRequire("cuGBI");

});
parcelRegister("cuGBI", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return $d7e07e65c4767f5c$export$4588528796d14202; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");
parcelRequire("eQupZ");
var $jHbOO = parcelRequire("jHbOO");

var $klmJ0 = parcelRequire("klmJ0");

var $li3ww = parcelRequire("li3ww");

var $1xw2Y = parcelRequire("1xw2Y");

var $lG0u6 = parcelRequire("lG0u6");

var $aL1Vp = parcelRequire("aL1Vp");
function $d7e07e65c4767f5c$export$4588528796d14202({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        background: (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM ? (0, $lG0u6.theme).greenBackground : (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jHbOO.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>{
            navigate("/login", {
                replace: true
            });
        },
        type: (0, $jHbOO.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        "data-testid": "message"
    }, (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgResetPasswordSent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgResetPasswordLinkSent"
    }))));
}

});
parcelRegister("eQupZ", function(module, exports) {
$parcel$export(module.exports, "LandingMessage", function () { return (parcelRequire("jHbOO")).LandingMessage; });
$parcel$export(module.exports, "LandingMessageType", function () { return (parcelRequire("jHbOO")).LandingMessageType; });
parcelRequire("jHbOO");

});
parcelRegister("jHbOO", function(module, exports) {

$parcel$export(module.exports, "LandingMessageType", function () { return $9473beb2168e9319$export$ead8dc60ae5441ac; });
$parcel$export(module.exports, "LandingMessage", function () { return $9473beb2168e9319$export$d88a99e06d24b3e0; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");
parcelRequire("7kOJ5");
var $eIlbE = parcelRequire("eIlbE");
parcelRequire("eCCbi");
var $jdB4b = parcelRequire("jdB4b");

var $8c5Kf = parcelRequire("8c5Kf");

var $lG0u6 = parcelRequire("lG0u6");

var $jyUmz = parcelRequire("jyUmz");
const $9473beb2168e9319$var$SWrapper = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $9473beb2168e9319$var$SIcon = (0, $akcQ4.default).div`
    padding-bottom: 30px;
`;
const $9473beb2168e9319$var$SBody = (0, $akcQ4.default).div`
    width: 550px;
    padding-bottom: 61px;
    line-height: 1.5em;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (max-width: 576px) {
        width: 100%;
    }
`;
const $9473beb2168e9319$var$SLink = (0, $akcQ4.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        cursor: pointer;
    }
`;
var $9473beb2168e9319$export$ead8dc60ae5441ac;
(function(LandingMessageType) {
    LandingMessageType["SUCCESS"] = "success";
    LandingMessageType["ERROR"] = "error";
    LandingMessageType["INFO"] = "info";
})($9473beb2168e9319$export$ead8dc60ae5441ac || ($9473beb2168e9319$export$ead8dc60ae5441ac = {}));
var $9473beb2168e9319$export$ea871832d7359f7e;
(function(LandingMessageTitle) {
    LandingMessageTitle["DEFAULT"] = "MyChargeSpace";
    LandingMessageTitle["ADMIN"] = "HaloAdmin";
})($9473beb2168e9319$export$ea871832d7359f7e || ($9473beb2168e9319$export$ea871832d7359f7e = {}));
const $9473beb2168e9319$var$renderIcon = (type)=>{
    if (type) {
        if (type === "success") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eIlbE.LandingMessageSuccessIcon), null);
        if (type === "error") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jdB4b.LandingMessageErrorIcon), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
            size: 90,
            fill: (0, $lG0u6.theme).brandColors.CA_Green
        });
    }
};
function $9473beb2168e9319$export$d88a99e06d24b3e0({ title: title, type: type, linkText: linkText, onClick: onClick, children: children, className: className, style: style, icon: icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9473beb2168e9319$var$SWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jyUmz.FormHeader), {
        "data-testid": "header",
        className: "mb-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9473beb2168e9319$var$SIcon, null, icon || $9473beb2168e9319$var$renderIcon(type)), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("h4", {
        className: "m-0 mb-3"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9473beb2168e9319$var$SBody, null, children), linkText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9473beb2168e9319$var$SLink, {
        onClick: onClick,
        "data-testid": "linkBtn"
    }, linkText) : null);
}

});
parcelRegister("7kOJ5", function(module, exports) {
$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return (parcelRequire("eIlbE")).LandingMessageSuccessIcon; });
parcelRequire("eIlbE");

});
parcelRegister("eIlbE", function(module, exports) {

$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return $7941e28cf79b4aff$export$cd9c9d539c03064b; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");
function $7941e28cf79b4aff$export$cd9c9d539c03064b({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        width: 90,
        height: 90,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
        fill: "#81E18B"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "m30.03 52.553 7.364 7.375 30.94-30.941 1.044 1.043-31.985 31.985-8.407-8.42-2.536-2.54-5.578-5.588 1.044-1.042 5.578 5.587 2.536 2.54Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475ZM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45Z"
    })));
}

});


parcelRegister("eCCbi", function(module, exports) {
$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return (parcelRequire("jdB4b")).LandingMessageErrorIcon; });
parcelRequire("jdB4b");

});
parcelRegister("jdB4b", function(module, exports) {

$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return $ca7a0f53997bf0ba$export$651986bbbb409f50; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");
function $ca7a0f53997bf0ba$export$651986bbbb409f50({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 90,
        height: 90,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
        fill: "#DF0017"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "m63.596 27.08-5.902 5.9-1.844 1.845-28.77 28.77-1.044-1.043 28.77-28.77 1.845-1.844 5.901-5.902 1.044 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M62.92 63.595 26.406 27.08l1.043-1.043 36.516 36.516-1.043 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475zM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45z"
    })));
}

});






parcelRegister("bMIKZ", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return (parcelRequire("87J91")).ResetPasswordRequestErrorPage; });
parcelRequire("87J91");

});
parcelRegister("87J91", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return $40b86d460697395d$export$74ef4c4eee19ea3d; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");
parcelRequire("eQupZ");
var $jHbOO = parcelRequire("jHbOO");

var $li3ww = parcelRequire("li3ww");

var $lG0u6 = parcelRequire("lG0u6");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");
const $40b86d460697395d$var$Title = (0, $akcQ4.default).div`
    font-size: 24px;
    padding-bottom: 20px;
`;
function $40b86d460697395d$export$74ef4c4eee19ea3d({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        background: (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jHbOO.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $jHbOO.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($40b86d460697395d$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSignUpError"
    })));
}

});



//# sourceMappingURL=index.64af470b.js.map
